import Axios from '@/config/AxiosConfig';

// getSearchResults
export const getSearch = async (query, type, page, additionalParams) => {
    let url = `/global-search?type=${type}&search_string=${query}&page_no=${page}`;
    if (additionalParams) {
        url += additionalParams;
    }
    try {
        const { data } = await Axios.get(url);
        return data;
    } catch (e) {
        return e.response;
    }
};
// getFilterResults
export const getFilter = async (type, additionalParams) => {
    let url = `/global-search-filter-data?type=${type}`;
    if (additionalParams) {
        url += additionalParams;
    }
    try {
        const { data } = await Axios.get(url);
        console.log(data, 'autocomplete data');
        return data;
    } catch (e) {
        return e.response;
    }
};

// add global search Logs
export const searchLogs = async (payload) => {
    const url = '/add-search-logs';

    try {
        const { data } = await Axios.post(url, payload);
        return data;
    } catch (e) {
        return e.response;
    }
};

// http://pms6-api.gnomen.io/api/v1/global-search-filter-data?type=property&property_cat_id=1,2
// http://pms6-api.gnomen.io/api/v1/global-search?type=property&search_string=gmail.com

// http://pms6-api.gnomen.io/api/v1/global-search-filter?type=contact
